import React from "react";
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import { useState } from "react";
import TalkModal from "./TalkModal";
import About from "./About";
import Projects from "./Projects";
import Contact from "./Contact";
import Navbar from "./Navbar";
import Home from "./Home";
import ProjectDetails from "./Projectdetails";
import FacialRecognition from "./Projects/FR";
import FacebookML from "./Projects/Facebook-ML"
import BoggleAlgorithms from "./Projects/Boggle";
import DataAnalysisStudentResponses from "./Projects/Students";
import ClubFinanceApp from "./Projects/ClubFinance";
import GymDatabase from "./Projects/Gym";
import PaperTrading from "./Projects/Trading";
import ImageGeneration from "./Projects/ImageGen";
import Maplee from "./Projects/maplee";
import Footer from "./components/footer";
import MapleeCurrent from "./Projects/mapleeCurrent";

export default function App() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="bg-gray-900 min-h-screen text-white">
      <Router basename="/">
        <Navbar setShowModal={setShowModal} />
        <TalkModal show={showModal} onClose={() => setShowModal(false)} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/facial-recognition" element={<FacialRecognition />} />
          <Route path="/projects/facebook-post-ml-analysis" element={<FacebookML />} />
          <Route path="/projects/boggle-algorithms" element={<BoggleAlgorithms />} />
          <Route path="/projects/data-analysis-of-student-responses" element={<DataAnalysisStudentResponses />} />
          <Route path="/projects/club-finance-app" element={<ClubFinanceApp />} />
          <Route path ="/projects/gym-database" element={<GymDatabase />} />
          <Route path="/projects/paper-trading" element={< PaperTrading />} />
          <Route path="/projects/image-generation" element={< ImageGeneration />} />
          <Route path="/projects/previous-maplee" element={<Maplee />} />
          <Route path="/projects/maplee-market-place" element={<MapleeCurrent />} />
          <Route path="/projects/:projectId" element={<ProjectDetails />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}
